export class DataModelUpdateStatutAdmin{
    public commandeId : number = 0
    public statutId : number = 0
}